(() => {
  const KEY = 'kk_favorites';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('kk:favorites-changed', { detail: { items } }));
    } catch (_) {}
  };

  const renderButton = (button) => {
    const active = read().some((item) => item.handle === button.dataset.productHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    const label = active ? 'Odstrani iz priljubljenih' : 'Dodaj med priljubljene';
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
  };

  const renderAll = () => {
    document.querySelectorAll('[data-kk-card-favorite]').forEach(renderButton);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kk-card-favorite]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (!handle) return;
    const items = read();
    const index = items.findIndex((item) => item.handle === handle);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push({
        handle,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || `/products/${handle}`,
        image: button.dataset.productImage || '',
      });
    }
    write(items);
    renderAll();
  });

  document.addEventListener('DOMContentLoaded', renderAll);
  document.addEventListener('shopify:section:load', renderAll);
  window.addEventListener('kk:favorites-changed', renderAll);
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) renderAll();
  });
})();
